export default __webpack_public_path__ + "static/media/img-escort-2.c39293d3.png";